import React from 'react';

export const Delete = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.16022 20.1127L4.38351 6.52039C4.34354 5.82086 4.9265 5.23268 5.65982 5.23268L17.8402 5.23269C18.5735 5.23269 19.1565 5.82086 19.1165 6.5204L18.3398 20.1127C18.3028 20.7603 17.7423 21.2673 17.0635 21.2673L6.43652 21.2673C5.75766 21.2673 5.19722 20.7603 5.16022 20.1127Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M9 6V4C9 2.89543 9.89543 2 11 2H13C14.1046 2 15 2.89543 15 4V5.33333"
      stroke="black"
      strokeWidth="1.5"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeWidth="1.5"
      x1="11.75"
      x2="11.75"
      y1="9.75"
      y2="16.25"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeWidth="1.5"
      x1="8.75"
      x2="8.75"
      y1="9.75"
      y2="16.25"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeWidth="1.5"
      x1="14.75"
      x2="14.75"
      y1="9.75"
      y2="16.25"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeWidth="1.5"
      x1="2.75"
      x2="21.25"
      y1="5.25"
      y2="5.25"
    />
  </svg>
);
